import React, { Component } from 'react';
import { Link } from "react-router-dom";

class DiaInterCC extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Día Internacional de la Cultura Científica. Conocer, comprender y transformar el mundo desde la ciencia
</h2>
          </header>
          <div className="containerimagenblog">
          <img className="imagenBlog" src="images/Blog/portada3.jpg" alt="Simulacro 2023" />
          </div>
          <span className="containerblog">
              <div className="align justify">
                <p>
                 Cada 28 de Septiembre celebramos el Día Internacional de la Cultura Científica, una fecha que nos
                  invita a reflexionar sobre la importancia de acercar el conocimiento científico a todas las personas. 
                  La ciencia no solo pertenece a los laboratorios o a los grandes descubrimientos: está presente en cada 
                  decisión que tomamos, en cómo entendemos nuestro entorno y en la forma en que imaginamos el futuro. 
                </p>
                <p>
                En el Museo Interactivo El Rehilete, creemos que la cultura científica es una herramienta fundamental 
                para el desarrollo individual y colectivo. Por eso, cada exposición, taller y experiencia que ofrecemos 
                está pensada para despertar la curiosidad, estimular el pensamiento crítico y fortalecer el acceso al 
                conocimiento de una manera divertida, interactiva y significativa.
                </p>
                <p>
                  La cultura científica no se trata únicamente de aprender datos o fórmulas, sino de entender cómo funciona 
                  el mundo, cuestionar lo que vemos y buscar soluciones creativas a los retos de nuestro tiempo. Desde comprender 
                  los fenómenos naturales hasta analizar los avances tecnológicos, la ciencia nos brinda las herramientas necesarias
                   para construir sociedades más informadas, responsables y sostenibles.
                </p>
                <p>
                  Celebrar este día es reconocer que la ciencia es parte de la cultura. Es un lenguaje común que nos conecta, nos enseña 
                  a observar con asombro y nos impulsa a participar activamente en la construcción de un mejor futuro.
                  En El Rehilete, seguimos comprometidos con difundir la ciencia de manera cercana, inclusiva y apasionante, convencidos 
                  de que fomentar la cultura científica en niñas, niños, jóvenes y adultos es apostar por un México más innovador, consciente 
                  y preparado para los desafíos del mañana.
                </p>
                <p>
                  <b>
                    Porque la ciencia también es cultura, y compartirla es una forma de transformar el mundo.
                  </b>
                </p>
            </div>
            <div>
              <div className="containerjuego">
                 <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default DiaInterCC;